// extracted by mini-css-extract-plugin
export default {"loader":"_1_qvuV3W","small":"_3r-JLOc_","white":"_2FdSjgun"};